import {combineReducers} from "redux";
import approvalViewModel from "./approvalViewModel";
import archiveDetailViewModel from "./archiveDetailViewModel";

const rootViewModel = combineReducers({
    approvalViewModel,
    archiveDetailViewModel,
});

export default rootViewModel;
